import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';
import AppUserData from '@/types/AppUser';

Vue.use(Vuex)

interface AppState {
    apiAccessToken: string;
    apiRefreshToken: string;
    appUser: string | null;
    locale: string;
    authType: string;
    cookieConsent: boolean;
}

const vuexLocal = new VuexPersist<AppState>({
    key: 'timereporting',
    storage: window.localStorage,
    reducer: (state: AppState) => ({
        locale: state.locale,
        apiRefreshToken: state.apiRefreshToken,
        cookieConsent: state.cookieConsent
    })
});

const vuexSession = new VuexPersist<AppState>({
    key: 'timereporting',
    storage: window.sessionStorage,
    reducer: (state: AppState) => ({
        apiAccessToken: state.apiAccessToken,
        appUser: state.appUser,
        authType: state.authType
    })
});

export default new Vuex.Store<AppState>({
    mutations: {
        setApiAccessToken(state, apiAccessToken: string) {
            state.apiAccessToken = apiAccessToken;
        },
        setApiRefreshToken(state, apiRefreshToken: string) {
            state.apiRefreshToken = apiRefreshToken;
        },
        setAppUser(state, appUser: AppUserData) {
            state.appUser = appUser ? JSON.stringify(appUser) : null;
        },
        setLocale(state, locale: string) {
            state.locale = locale;
        },
        setAuthType(state, authType: string) {
            state.authType = authType;
        },
        setCookieConsent(state, cookieConsent: boolean) {
            state.cookieConsent = cookieConsent;
        }
    },
    getters: {
        appUser: (state) => {
            if (!state.appUser) {
                return null;
            }
            return JSON.parse(state.appUser as string) as AppUserData
        },
        authType: (state) => {
            if (!state.authType) {
                return null;
            }
            return state.authType;
        },
        apiAccessToken: (state) => {
            if (!state.apiAccessToken) {
                return null;
            }
            return state.apiAccessToken;
        },
        cookieConsent: (state) => {
            if (!state.cookieConsent) {
                return null;
            }
            return state.cookieConsent;
        },
    },
    actions: {
        setApiAccessToken(context, apiAccessToken: string) {
            return new Promise((resolve) => {
                context.commit('setApiAccessToken', apiAccessToken);
                resolve();
            });            
        },
        setApiRefreshToken(context, apiRefreshToken: string) {
            return new Promise((resolve) => {
                context.commit('setApiRefreshToken', apiRefreshToken);
                resolve();
            });
        },
        setAppUser(context, appUser: AppUserData) {
            return new Promise((resolve) => {
                context.commit('setAppUser', appUser);
                resolve();
            });            
        },
        setLocale(context, locale: string) {
            return new Promise((resolve) => {
                context.commit('setLocale', locale);
                resolve();
            });
        },
        setAuthType(context, authType: string) {
            return new Promise((resolve) => {
                context.commit('setAuthType', authType);
                resolve();
            });
        },
        setCookieConsent(context, cookieConsent: boolean) {
            return new Promise((resolve) => {
                context.commit('setCookieConsent', cookieConsent);
                resolve();
            });
        }
    },
    plugins: [
        vuexLocal.plugin,
        vuexSession.plugin
    ]
})
